<div class="ms-auto">
  Powered by
  <a href="https://www.wbsolution.co/products/insurance-hub" target="_blank">
    <span> Webble IT Solution</span>
  </a>
</div>
